import { IDR } from '@/libs/currency'

/* eslint-disable import/prefer-default-export */
export const chooseAction = [
  {
    label: 'Transfer Sekarang',
    value: 'transfer_now',
  },
  {
    label: 'Transfer Manual',
    value: 'transfer_manual',
  },
  {
    label: 'Review',
    value: 'review',
  },
  {
    label: 'Tolak',
    value: 'tolak',
  },
]

export const listDetailWithdrawal = [
  {
    key: 'created_at',
    label: 'Tanggal',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '100px',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'type',
    label: 'Jenis Transaksi',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '100px',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'nominal',
    label: 'Jumlah',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '100px',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
  {
    key: 'saldo',
    label: 'Saldo',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '100px',
    },
    tdClass: 'text-black',
    class: 'p-1',
    formatter: value => IDR(value),
  },
  {
    key: 'action',
    label: 'Action',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
    },
    tdClass: 'text-black',
    class: 'p-1',
  },
]

export const listWithdrawal = [
  {
    key: 'created_at',
    label: 'Tanggal',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '120px',
    },
  },
  {
    key: 'mitra_warehouse',
    label: 'Nama',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '150px',
    },
  },
  {
    key: 'bank_name',
    label: 'Nama Bank',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '150px',
    },
    formatter: value => value || '-',
  },
  {
    key: 'bank_account_no',
    label: 'No Rekening',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '150px',
    },
  },
  {
    key: 'nominal',
    label: 'Nominal',
    class: 'border-b-0 text-black p-1 text-start',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '150px',
    },
    formatter: value => IDR(value),
  },
  {
    key: 'status',
    label: 'Status',
    class: 'border-b-0 text-black p-1 text-center',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '14px',
      color: 'black',
      minWidth: '200px',
    },
  },
]

export const statusOptionsListWithdrawal = [
  {
    value: null,
    text: 'Pilih Status',
    disabled: true,
  },
  {
    value: '',
    text: 'Semua',
  },
  {
    value: 'requested',
    text: 'Request Penarikan',
  },
  {
    value: 'on_review',
    text: 'Sedang Direview',
  },
  {
    value: 'completed',
    text: 'Disetujui',
  },
  {
    value: 'rejected',
    text: 'Ditolak',
  },
  {
    value: 'on_process',
    text: 'Diproses',
  },
]
